import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import "./style.css";
import ActionBtn from "@/components/ActionBtn";
import { useNavigate } from "react-router-dom";
import ScreenHeader from "@/components/ScreenHeader";
import Card from "../../../shared/Card/Card";
import Badge from "../../../shared/Badge/Badge";

const QuotationHeader = ({ quotationData, patientData }) => {
  const { t } = useTranslation();
  
const navigate = useNavigate()

const cardClassName = "qp-info-panel"
  return (
    <div className="qp-header-card bg-white">
      <div className="qp-header-top">
        <Badge title={`CASE ID: #${patientData?.requestData?.id}`} className="qp-case-badge" />
        <ActionBtn title={t("view-patient-details")} icon="solar:eye-outline" onApply={() => navigate(`/panel/account-manager/medical-reports/${patientData?.requestData?.id}`)} className="qp-view-btn m-0" />
      </div>
      <ScreenHeader title={t("process-journey-quotation")} subtitle={t("quotation-process-sub")} className="m-0 mb-2 bg-transparent p-0 qp-header-title" />
      <div className="qp-info-row">
      <Card title={t("patient")} value={patientData?.patientData?.name || "--"} className={cardClassName} />
      <Card title={t("broker")} value={quotationData?.brokerName || "--"} className={cardClassName} />
      </div>
    </div>
  );
};

export default QuotationHeader;
